/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_Templates_HintInputs */

const cs_settings_automation_templates_hint = /** @type {(inputs: Settings_Automation_Templates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověřené startéry s větvemi, cronem, webhooky a paralelním fan-outem.`)
};

const en_settings_automation_templates_hint = /** @type {(inputs: Settings_Automation_Templates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Battle-tested starters with branching, cron, webhooks, and fan-out.`)
};

/**
* | output |
* | --- |
* | "Battle-tested starters with branching, cron, webhooks, and fan-out." |
*
* @param {Settings_Automation_Templates_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_templates_hint = /** @type {((inputs?: Settings_Automation_Templates_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_Templates_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_templates_hint(inputs)
	return cs_settings_automation_templates_hint(inputs)
});